import { updateApolloCache } from '@famly/vet_apollo-utils_update-apollo-cache';
import { GetInstitutionInfo } from './get-institution-info.query';
import { applyToggledFeaturesToInstitutionInfo } from './apply-toggled-features-to-institution-info';
import { useSubscribableToggleFeatureMutation } from './use-subscribable-toggle-feature-mutation';
export const useToggleFeatureMutation = (institutionId, options) => {
    const [toggleFeaturesMutation, { loading: toggleFeaturesMutationLoading }] = useSubscribableToggleFeatureMutation({
        refetchQueries: options === null || options === void 0 ? void 0 : options.refetchQueries,
        awaitRefetchQueries: Boolean(options === null || options === void 0 ? void 0 : options.refetchQueries),
        update: updateApolloCache()({
            cacheQuery: GetInstitutionInfo,
            cacheVariables: { institutionId },
            updater: (cachedData, newData) => applyToggledFeaturesToInstitutionInfo(cachedData, institutionId, newData.institutions.managedFeatures.setFeatures),
        }),
    });
    return { toggleFeaturesMutation, toggleFeaturesMutationLoading };
};
